import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b24018f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("发送网络请求")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发送邮件")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "Header请求头", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 添加")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("表单")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("固定")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "Header请求参数 ", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参数类型 - ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("json")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("form")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("表单")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("固定")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请求结果处理", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20px"} }, "自定义脚本: ", -1))
const _hoisted_17 = {
  key: 0,
  class: "item-desc"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 👉 返回值为 ture 则流程通过，为 false 则流程将被驳回 ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 支持函数 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"dodgerblue"} }, [
    /*#__PURE__*/_createTextVNode("setFormByName( "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#939494"} }, "'表单字段名', '表单字段值'"),
    /*#__PURE__*/_createTextVNode(" )")
  ]),
  /*#__PURE__*/_createTextVNode(" 可改表单数据 ")
], -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请求成功😀：", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请求失败😥：", -1))
const _hoisted_25 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "90px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "选择触发的动作",
          prop: "text",
          class: "user-type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.config.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.type) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "WEBHOOK" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "EMAIL" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.config.type === 'WEBHOOK')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_form_item, {
                label: "请求地址",
                prop: "text"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入URL地址",
                    size: "default",
                    modelValue: _ctx.config.http.url,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.http.url) = $event))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.config.http.method,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.http.method) = $event)),
                        style: {"width":"85px"},
                        placeholder: "URL"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "GET",
                            value: "GET"
                          }),
                          _createVNode(_component_el_option, {
                            label: "POST",
                            value: "POST"
                          }),
                          _createVNode(_component_el_option, {
                            label: "PUT",
                            value: "PUT"
                          }),
                          _createVNode(_component_el_option, {
                            label: "DELETE",
                            value: "DELETE"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Header请求头",
                prop: "text"
              }, {
                label: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_el_button, {
                    type: "text",
                    icon: "Plus",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addItem(_ctx.config.http.headers)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.http.headers, (header, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: header.name
                    }, [
                      _createVNode(_component_el_input, {
                        placeholder: "参数名",
                        size: "default",
                        style: {"width":"100px"},
                        modelValue: header.name,
                        "onUpdate:modelValue": ($event: any) => ((header.name) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_radio_group, {
                        size: "default",
                        style: {"margin":"0 5px"},
                        modelValue: header.isField,
                        "onUpdate:modelValue": ($event: any) => ((header.isField) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: true }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: false }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                      (header.isField)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            style: {"width":"180px"},
                            modelValue: header.value,
                            "onUpdate:modelValue": ($event: any) => ((header.value) = $event),
                            size: "default",
                            placeholder: "请选择表单字段"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItems, (form) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: form.id,
                                  label: form.title,
                                  value: form.title
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            placeholder: "请设置字段值",
                            size: "default",
                            modelValue: header.value,
                            "onUpdate:modelValue": ($event: any) => ((header.value) = $event),
                            style: {"width":"180px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])),
                      _createVNode(_component_el_icon, {
                        size: "1.5em",
                        onClick: ($event: any) => (_ctx.delItem(_ctx.config.http.headers, index)),
                        style: {"margin-left":"5px","color":"#c75450","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Delete)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Header请求参数",
                prop: "text"
              }, {
                label: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_component_el_button, {
                    icon: "Plus",
                    style: {"margin-right":"20px"},
                    type: "text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addItem(_ctx.config.http.params)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _hoisted_10,
                  _createVNode(_component_el_radio_group, {
                    size: "small",
                    modelValue: _ctx.config.http.contentType,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.http.contentType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: "JSON" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "FORM" }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.http.params, (param, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: param.name
                    }, [
                      _createVNode(_component_el_input, {
                        placeholder: "参数名",
                        size: "default",
                        style: {"width":"100px"},
                        modelValue: param.name,
                        "onUpdate:modelValue": ($event: any) => ((param.name) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_radio_group, {
                        size: "default",
                        style: {"margin":"0 5px"},
                        modelValue: param.isField,
                        "onUpdate:modelValue": ($event: any) => ((param.isField) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_button, { label: true }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio_button, { label: false }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                      (param.isField)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            style: {"width":"180px"},
                            modelValue: param.value,
                            "onUpdate:modelValue": ($event: any) => ((param.value) = $event),
                            size: "default",
                            placeholder: "请选择表单字段"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItems, (form) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: form.id,
                                  label: form.title,
                                  value: form.title
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            placeholder: "请设置字段值",
                            size: "default",
                            modelValue: param.value,
                            "onUpdate:modelValue": ($event: any) => ((param.value) = $event),
                            style: {"width":"180px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])),
                      _createVNode(_component_el_icon, {
                        size: "1.5em",
                        onClick: ($event: any) => (_ctx.delItem(_ctx.config.http.params, index)),
                        style: {"margin-left":"5px","color":"#c75450","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Delete)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "请求结果处理",
                prop: "text"
              }, {
                label: _withCtx(() => [
                  _hoisted_15,
                  _hoisted_16,
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.config.http.handlerByScript,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config.http.handlerByScript) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                default: _withCtx(() => [
                  (_ctx.config.http.handlerByScript)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_20))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, "👉 无论请求结果如何，均通过")),
                  (_ctx.config.http.handlerByScript)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", null, [
                          _hoisted_23,
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.config.http.success,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config.http.success) = $event)),
                            rows: 3
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_24,
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.config.http.fail,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.config.http.fail) = $event)),
                            rows: 3
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : (_ctx.config.type === 'EMAIL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_el_form_item, {
                  label: "邮件主题",
                  prop: "text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入邮件主题",
                      size: "default",
                      modelValue: _ctx.config.email.subject,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.config.email.subject) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "收件方",
                  prop: "text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      size: "small",
                      style: {"width":"100%"},
                      modelValue: _ctx.config.email.to,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.config.email.to) = $event)),
                      filterable: "",
                      multiple: "",
                      "allow-create": "",
                      "default-first-option": "",
                      placeholder: "请输入收件人"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.email.to, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "邮件正文",
                  prop: "text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      modelValue: _ctx.config.email.content,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.config.email.content) = $event)),
                      rows: 4,
                      placeholder: "邮件内容，支持变量提取表单数据 ${表单字段名} "
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}